export enum EngagementType {
  B2B = 'B2B',
  Individuals = 'Individuals',
}
